export default "__VITE_ASSET__Di$ggLYi__"